import React, { useEffect, useRef, useState } from 'react'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import useTrans from '@hooks/useTrans'
import { Search } from '@components/icons'
import { Button } from '@components/atoms'
import styles from './FormGeocoder.module.sass'
// import { trackingGAevent } from '@utils/gtm'

interface Props {
  setResult: React.Dispatch<React.SetStateAction<any>>
  className?: string
}

const FormGeocoder = (props: Props) => {
  const { setResult = undefined, className = '' } = props

  const t = useTrans()
  const geocoderContainerRef = useRef(null)

  const [geocoderMapbox, setGeocoderMapbox] = useState(null)
  const [testoRicerca, setTestoRicerca] = useState(null)

  const search = () => {
    if (testoRicerca) {
      geocoderMapbox.query(testoRicerca)
    }
  }

  useEffect(() => {
    const geocoder = new MapboxGeocoder({
      accessToken: `${process.env.MAPBOX_ACCESS_TOKEN}`,
      placeholder: t('Cerca una provincia o un comune'),
      countries: 'it',
      mapboxgl: null,
    })

    geocoder.on('result', (e) => {
      setResult(e?.result)
    })

    geocoderContainerRef.current.append(geocoder.onAdd())

    const inputElement = geocoderContainerRef.current.querySelector(
      '.mapboxgl-ctrl-geocoder--input'
    )
    const suggestions = geocoderContainerRef.current.querySelector('.suggestions')
    const handleInput = (e) => {
      setTestoRicerca(e.target.value)
    }

    inputElement.addEventListener('input', handleInput)

    const mutationObserver = new MutationObserver((mutationList) => {
      for (const item of mutationList) {
        const target = item.target as HTMLElement
        if (item.type === 'childList') {
          inputElement.removeAttribute('aria-activedescendant')
          for (let i = 0; i < target.children.length; i++) {
            const child = target.children[i]
            const childId = `form-geocoder-${i}`
            child.setAttribute('id', childId)
            child.setAttribute('role', 'option')
            if (child.classList.contains('active')) {
              inputElement.setAttribute('aria-activedescendant', childId)
            }
          }
        }
        if (item.type === 'attributes') {
          // cambia style="display: block/none" - per sicurezza controllo l'altezza
          inputElement.setAttribute('aria-expanded', target.clientHeight > 0 ? 'true' : 'false')
          inputElement.removeAttribute('aria-activedescendant')
        }
      }
    })
    if (suggestions) {
      suggestions.setAttribute('id', 'form-geocoder-suggestions')
      suggestions.setAttribute('role', 'listbox')
      inputElement.setAttribute('role', 'combobox')
      inputElement.setAttribute('aria-autocomplete', 'list')
      inputElement.setAttribute('aria-haspopup', 'listbox')
      inputElement.setAttribute('aria-controls', 'form-geocoder-suggestions')
      mutationObserver.observe(suggestions, { childList: true, attributes: true })
    }

    setGeocoderMapbox(geocoder)

    return () => {
      geocoder.onRemove()
    }
  }, [])

  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.inputWrap}>
        <div ref={geocoderContainerRef} className={styles.geocoderSearch} />
        <button
          type="submit"
          onClick={() => search()}
          className={styles.submitIcon}
          aria-label={t('Cerca')}
        >
          <Search />
        </button>
        <span className={styles.icon}>
          <Search />
        </span>
      </div>
      <Button label={t('Cerca')} onClick={() => search()} className={styles.submit} />
    </div>
  )
}

export default FormGeocoder
